import { render, staticRenderFns } from "./link-manage.vue?vue&type=template&id=cf0a2acc&scoped=true"
import script from "./link-manage.vue?vue&type=script&lang=js"
export * from "./link-manage.vue?vue&type=script&lang=js"
import style0 from "./link-manage.vue?vue&type=style&index=0&id=cf0a2acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0a2acc",
  null
  
)

export default component.exports